module.exports = {"350481001":"燕东街道","350481002":"燕西街道","350481003":"燕南街道","350481004":"燕北街道","350481100":"西洋镇","350481101":"贡川镇","350481102":"安砂镇","350481103":"小陶镇","350481104":"大湖镇","350481105":"曹远镇","350481106":"洪田镇","350481107":"槐南镇","350481202":"上坪乡","350481203":"罗坊乡","350481204":"青水乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350481.json
// module id = 1100
// module chunks = 0